import { createTheme } from "@material-ui/core";

export const theme = createTheme({
  mixins: {
    toolbar: {
      minHeight: 64,
    },
  },
  palette: {
    primary: {
      main: "#177739",
      light: "#6AAF52",
    },
    secondary: {
      main: "#8BC68E",
    },
    background: {
      paper: "#fff",
      default: "#F6F8FD",
    },
    error: {
      main: "#EB5757",
      light: "#EB5757",
    },
    warning: {
      main: "#ff9800",
      light: "#ffc045",
    },
  },
  typography: {
    body1: {
      fontWeight: 500,
      fontStyle: "normal",
    },
    body2: {
      fontWeight: 400,
      fontStyle: "normal",
    },
    subtitle1: {
      fontWeight: 500,
      fontStyle: "normal",
    },
    subtitle2: {
      fontWeight: 400,
      fontStyle: "normal",
    },
  },
});

export const customTheme = {
  mixins: {
    tabbar: {
      minHeight: 35,
      height: 35,
      minHeightMobile: 65,
      heightMobile: 65,
    },
  },
};
